<div class="min-h-60">
  <div
    class="px-6 py-3 pb-5 mh-table-custom d-flex flex-column justify-content-between"
    [ngClass]="{
      'pt-6': !showCardHeader,
      'pe-3': vertical_scrollbar,
      'pe-6': !vertical_scrollbar
    }"
  >
    <div id="widget-table" class="table-responsive h-table-body">
      @if(loading){
      <div class="col-12 loading-fixed">
        <app-progress-loading [isLoading]="loading"></app-progress-loading>
      </div>
      }
      <table class="table align-middle gs-0 gy-4 mb-0">
        <thead id="table_header">
          <tr class="fw-bolder text-gray-600 bg-gray-200 position-sticky">
            <!-- @for (header of dataColumns; track header; let column_index =
            $index) {
            <th
              [ngClass]="{
                'ps-4 rounded-start': column_index < 1,
                '': 0 < column_index && column_index > dataColumns.length - 1,
                'rounded-end pe-4': column_index === dataColumns.length - 1
              }"
              class="{{ header.headerClass }}"
            >
              {{ header.name | translate }}
            </th>
            } -->
          </tr>
        </thead>
        <tbody>
          @if(sources.data.length){ @for (row of sources.data; track row.id; let
          row_index = $index) {
          <tr
            [ngClass]="{
              'cursor-pointer': rowClick,
            }"
            (click)="clickedRow(row)"
            [id]="'row_' + (row_index + 1)"
          >
            <td class="rounded px-4">
              <div class="pb-0">
                <div class="d-flex mb-5">
                  <div class="d-flex align-items-center flex-grow-1">
                    <div class="symbol symbol-circle symbol-45px me-5">
                      @if (row.student.image_url) {
                      <img [src]="fileUrl + row.student.image_url!" class="object-fit-cover" />
                      } @else {
                      <span class="symbol-label bg-light-primary text-primary">
                        <app-keenicon name="user" class="fs-2 text-primary"></app-keenicon>
                      </span>
                      }
                    </div>
                    <div class="d-flex flex-column">
                      <a class="text-gray-800 fs-6 fw-bold">
                        {{ row.student.full_name }} </a
                      ><span class="text-gray-500 fw-semibold">{{
                        row.created_at | timeInterval
                      }}</span>
                    </div>
                  </div>
                  <div class="d-flex flex-column justify-content-start h-100">
                    <app-rating-star
                      [rating]="row.rating || row.score || 0"
                    ></app-rating-star>
                  </div>
                </div>
                <div class="">
                  <p class="text-gray-700 fw-normal fs-5">
                    {{ row.review }}
                  </p>
                  <div class="d-flex align-items-center mb-5"></div>
                </div>
                @if(row_index != sources.data.length-1){

                <div class="separator mb-4"></div>
                }
              </div>
            </td>
          </tr>
          } }@else{
          <tr class="text-center">
            <td [colSpan]="dataColumns.length">
              <ng-container *ngTemplateOutlet="noData"></ng-container>
            </td>
          </tr>

          }
        </tbody>
      </table>
    </div>
    @if(sources.data.length){
    <div class="pagination-fixed bg-white px-4">
      <app-paginations
        [dataSource]="sources"
        [isLoading]="loading"
        (onPageChange)="onTableChange($event)"
      ></app-paginations>
    </div>
    }
  </div>
</div>

<ng-template #noData>
  <div
    class="d-flex justify-content-center align-items-center h-inherit text-gray-600 fw-normal fs-6 pt-2"
  >
    {{ "TABLE.NO_DATA_DISPLAY" | translate }}
  </div>
</ng-template>
